import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 480px;
  margin: 0 auto;
  background: #eae8e9;
  min-height: 100vh;
  padding: 0;
`;

export const WhiteBox = styled.div`
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
`;

export const Title = styled.div`
  font-size: 26px;
  font-weight: 700;
  color: #222;
  padding-top: 12px;
  margin-bottom: 28px;
  text-align: left;
  padding-left: 24px;
`;

export const colors = {
  grayBg: '#eae8e9',
  white: '#fff',
  main: '#1976d2',
  text: '#222',
  subText: '#888',
}; 